import type { CSSProperties } from 'react';

export const filterInputBaseStyle: CSSProperties = {
  width: '100%',
  padding: '2px 0',
  fontSize: '0.75rem',
  border: 'none',
  outline: 'none',
  background: 'transparent',
};
